import React, { useMemo } from 'react';
import { styled } from 'styled-components';
import { Popover } from 'antd';
import { ImTruck } from 'react-icons/im';
import { Column, ReadOnlyItem, Text, Title } from '@ydistri/ds';
import { CalculationResponse } from '@ydistri/api-sdk';
import { format } from 'date-fns';
import { ICON_SIZE_COMPACT, ICON_SIZE_NORMAL } from './calculationRowLib';
import { computeRemSize } from '@ydistri/theme';

const ProductionCalculationIndicatorWrapper = styled.div`
  margin-left: auto;
  color: #839883;
`;

interface ProductionCalculationIndicatorProps {
  finishExecutionUntil: CalculationResponse['finishExecutionUntil'];
  compact?: boolean;
}

const ProductionCalculationIndicator: React.FC<ProductionCalculationIndicatorProps> = ({
  finishExecutionUntil,
  compact,
}) => {
  const popoverContent = useMemo(() => {
    if (!finishExecutionUntil) return null;

    return (
      <Column>
        <Title>Production calculation</Title>
        <ReadOnlyItem
          label="Finish execution until"
          value={format(new Date(finishExecutionUntil), 'd. M. yyyy')}
        />
        <Text>
          This calculation will affect available supply for next calculations up to this date.
        </Text>
      </Column>
    );
  }, [finishExecutionUntil]);

  return (
    <Popover content={popoverContent}>
      <ProductionCalculationIndicatorWrapper data-type="indicator-calculation-production">
        <ImTruck size={computeRemSize(compact ? ICON_SIZE_COMPACT : ICON_SIZE_NORMAL)} />
      </ProductionCalculationIndicatorWrapper>
    </Popover>
  );
};

export default ProductionCalculationIndicator;
